import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, combinedSettingsSelector } from "@client/selectors";
import { type AppState } from "@client/types/AppState";
import Component, { type VideoComponentProps } from "./component";

const makeMapStateToProps = () => {
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    "aspectRatio",
    { name: "controls", prop: "showControls" },
    "loop",
    "mute",
    { name: "videoAutoplay", prop: "autoPlay" },
    { name: "videoType", prop: "type" },
    { name: "videoVimeoID", prop: "vimeoId" },
    { name: "videoYouTubeID", prop: "youTubeId" },
    { name: "videoWistiaID", prop: "wistiaId" }
  ]);

  return (state: AppState, props: RootContainerProps): VideoComponentProps => {
    const { aspectRatio, ...settings } = settingsSelector(state, props);
    return {
      ...props,
      ...settings,
      aspectRatio: settings.type === "file" || settings.type === "wistia" ? "16/9" : aspectRatio,
      mute: settings.autoPlay || settings.mute
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
